import { ResponseCode } from '@services/responseCode';
import ServeType from '@/constants/ServeType';

const isAppServeTypeOpen = (data) => {
  const availableServeTypes = data?.webStoreVo?.availableServeTypes
    ? data.webStoreVo.availableServeTypes
    : [];

  console.log('isAppServeTypeOpen', availableServeTypes);
  let isAleastOneOpen = false;

  if (
    availableServeTypes.includes(ServeType.DINE_IN) &&
    data?.webStoreVo?.dineInEnable
  ) {
    isAleastOneOpen = true;
  } else if (
    availableServeTypes.includes(ServeType.TAKE_OUT) &&
    data?.webStoreVo?.takeoutEnable
  ) {
    isAleastOneOpen = true;
  } else if (
    availableServeTypes.includes(ServeType.DELIVERY) &&
    data?.webStoreVo?.isDeliveryEnable
  ) {
    isAleastOneOpen = true;
  }
  return isAleastOneOpen;
};

const formatServiceSuspended = (intl, res) => {
  let tempString = intl.formatMessage({
    id: `error.network`,
  });

  console.log('formatServiceSuspended', res);
  if (res?.code === ResponseCode.STORE_OFF_LINE) {
    tempString = intl.formatMessage({
      id: `error.50003`,
    });
  } else if (
    res?.code === ResponseCode.NO_ERROR &&
    !isAppServeTypeOpen(res?.data)
  ) {
    tempString = intl.formatMessage({
      id: `welcome.machine.off.serveType`,
    });
  }
  return tempString;
};

export default formatServiceSuspended;
